import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { SuffixesService } from 'src/services/data/suffixes.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createSuffix, createSuffixFailure, createSuffixSuccess, deleteSuffix, deleteSuffixFailure, deleteSuffixSuccess, loadSuffixes, loadSuffixesFailure, loadSuffixesSuccess, updateSuffix, updateSuffixFailure, updateSuffixSuccess } from './suffix.actions'

@Injectable()
export class SuffixEffects {
  private actions$ = inject(Actions)
  private Suffixes = inject(SuffixesService)
  private toaster = inject(ToasterService)


  loadSuffixes$ = createEffect(() => this.actions$.pipe(
    ofType(loadSuffixes),
    switchMap(() =>
      from(this.Suffixes.getSuffixes()).pipe(
        map(suffixes => loadSuffixesSuccess({ suffixes })),
        catchAndLog(this.toaster, 'Unable to fetch suffixes', loadSuffixesFailure)))))

  createSuffix$ = createEffect(() => this.actions$.pipe(
    ofType(createSuffix),
    tap(() => this.toaster.progress('Creating suffix...')),
    switchMap(action =>
      from(this.Suffixes.create(action.suffix)).pipe(
        map(suffix => createSuffixSuccess({ suffix })),
        tap(() => this.toaster.success('Suffix created successfully.')),
        catchAndLog(this.toaster, 'Unable to create suffix', createSuffixFailure)))))

  updateSuffix$ = createEffect(() => this.actions$.pipe(
    ofType(updateSuffix),
    tap(() => this.toaster.progress('Updating suffix...')),
    switchMap(action =>
      from(this.Suffixes.update({ ...action.suffix, suffix_id: action.id })).pipe(
        map(suffix => updateSuffixSuccess({ suffix })),
        tap(() => this.toaster.success('Suffix updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update suffix', updateSuffixFailure)))))

  deleteSuffix$ = createEffect(() => this.actions$.pipe(
    ofType(deleteSuffix),
    tap(() => this.toaster.progress('Deleting suffix...')),
    switchMap(action =>
      from(this.Suffixes.remove(action.id)).pipe(
        map(() => deleteSuffixSuccess({ id: action.id })),
        tap(() => this.toaster.success('Suffix deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete suffix', deleteSuffixFailure)))))
}